import React, { useEffect, useState } from "react";
import LogoImg from "../../assets/img/logo.png";
import { BellAlertIcon, Cog6ToothIcon } from "@heroicons/react/24/outline";
import { useNotification } from "../../store";
import Sidebar from "../../components/utils/Sidebar";
import { ArrowLeftIcon, Bars3Icon, } from "@heroicons/react/24/outline";
import DatePicker, { DateObject } from "react-multi-date-picker";

const Notifications = () => {
  const { getNotifications, setNotificationAsRead } = useNotification();
  const [notifications, setNotifications] = useState<any[]>([]);
  const [displayNotif, setDisplayNotif] = useState<boolean>(false);
  const [displayMenu, setDisplayMenu] = useState<boolean>(false);
  const [displayDatePicker, setDisplayDatePicker] = useState<boolean>(false);
  const [selectedNotif, setSelectedNotif] = useState<any>();
  const [year, setYear]  = useState<number | undefined>()
  const [month, setMonth]  = useState<number | undefined>()
  const [day, setDay]  = useState<number | undefined>()
  const [startDate, setStartDate]  = useState<string | undefined>()
  const [endDate, setEndDate]  = useState<string | undefined>()
  const [dateValue, setDateValue] = useState<any>();

  useEffect(() => {
    loadNotifications();
  }, []);

  const loadNotifications = async () => {
    const data = {
      start_date: startDate, 
      end_date: endDate, 
      year: year, 
      month: month, 
      day: day,
    }
    const response = await getNotifications(data);
    if (response && response.res.toLowerCase() === 'success'){setNotifications(response.data);}
  };

  const markAsread = async (id: string) => {
    const notif = notifications.find((notif) => notif.id === id)
    setSelectedNotif(notif);
    setDisplayNotif(true);
    // console.log(notif);
    if (notif.status === "unread") {
      const res = await setNotificationAsRead(id);
      await loadNotifications();
    }
  };

  useEffect(()=>{
    if (typeof(dateValue) !== 'undefined'){
      if (dateValue.length === 1){
        if (dateValue[0] instanceof DateObject) {
          const date = dateValue[0].toDate()
          setDay(date.getDate())
          setMonth(date.getMonth() + 1)
          setYear(date.getFullYear())
          setStartDate(undefined)
          setEndDate(undefined)
        }
      }
      else if (dateValue.length === 2){
        var start = dateValue[0].toDate()
        start = start.getFullYear() + '-' + (start.getMonth() + 1) + '-' + start.getDate()
        var end = dateValue[1].toDate()
        end = end.getFullYear() + '-' + (end.getMonth() + 1) + '-' + end.getDate()
        setStartDate(start)
        setEndDate(end)
        setDay(undefined)
        setMonth(undefined)
        setYear(undefined)
      }
    }
  }, [dateValue])

  return (
    <div className="h-full w-full overflow-hidden">
      {displayMenu && <Sidebar /> }
      <div className="h-16 w-full  bg-white p-1 flex justify-between items-center">
        <img src={LogoImg} alt="logo" className="w-16 h-16 rounded-full" />
        {displayMenu ? (
          <button
            onClick={() => setDisplayMenu(false)}
            className="rounded-2xl w-12 h-12 flex justify-center items-center border aspect-square"
          >
            <ArrowLeftIcon className="w-8" />
          </button>
        ) : (
          <button
            onClick={() => setDisplayMenu(true)}
            className="rounded-2xl w-12 h-12 flex justify-center items-center border aspect-square"
          >
            <Bars3Icon className="w-8" />
          </button>
        )}
      </div>
      {displayNotif && (
        <div
          className="absolute w-full h-screen bg-black bg-opacity-70  z-40 flex flex-col justify-end"
          onClick={() => setDisplayNotif(false)}
        >
          <div className="mx-auto bg-white bg-opacity-100 w-full rounded-t-2xl  py-16 z-50">
            <center>
              <h2 className="text-md text-red-500 mb-3"> {new Date(Date.parse(selectedNotif.created_at)).toLocaleString()} </h2>
              <h2 className="text-xs text-primary">{selectedNotif.subject.charAt(0).toUpperCase() + selectedNotif.subject.slice(1)} </h2>
              <p className="text-xs mt-3"> {selectedNotif.message}</p>
            </center>
            
          </div>
        </div>
      ) }

      <div className="space-y-4 h-[calc(100%-4rem)] overflow-auto p-8">
        <h2 className="text-primary text-lg">Mes notifications</h2>
        {displayDatePicker ? 
          <>
            <div className='w-full bg-white shadow-sm p-2 rounded-xl '>
              <p className="text-xs text-gray-500">Veuillez sélectionner une date ou une plage de dates</p>
              <div className='w-full p-2 flex items-center '>
                <DatePicker  
                  onChange={setDateValue} 
                  range 
                  className='rounded-2xl flex justify-center items-center border '
                /> 
                <button
                  onClick={() => loadNotifications()}
                  className="rounded-md w-12 bg-green-600 flex justify-center ml-6 items-center border "
                >
                  Filtrer
                </button>
              </div>
            </div>
          </>
          :
          <button
            onClick={() => setDisplayDatePicker(true)}
            className="rounded-2xl bg-green-300 flex justify-center items-center border p-2"
          >
            Filtrer les notifications
          </button>
        }
        <div className="w-full  space-y-4">
          {notifications.map((notification:any, idx:any) => (
            <div
              onClick={() => markAsread(notification.id)}
              key={idx}
              className={`w-full ${
                notification.status === "unread" ? "bg-white " : "bg-gray-300"
              } shadow-sm p-2 flex items-center justify-between rounded-xl gap-2`}
            >
              <div className="p-2 flex gap-2 items-center">
                <BellAlertIcon className="w-8 h-8 mx-auto text-tertiary" />
                <div>
                  <h3 className="text-xs text-primary">
                    {notification.subject}
                  </h3>
                  <p className="text-[8px] text-gray-400">
                    {notification.message}
                  </p>
                </div>
              </div>
              <div>
                <p className="text-xs text-gray-500">
                  {new Date(Date.parse(notification.created_at)).toLocaleString()} 
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Notifications;
